import React from "react";
import { Accordion, AccordionProps } from "@mui/material";
import "./styles.scss";

type ScdAccordionProps = Omit<AccordionProps, "classes">;

export function ScdAccordion(props: ScdAccordionProps): React.JSX.Element {
  const { children, ...rest } = props;
  const classNameBase = "scd-accordion";

  return (
    <Accordion
      {...rest}
      classes={{
        root: `${classNameBase}`,
        rounded: `${classNameBase}-rounded`,
        expanded: `${classNameBase}-expanded`,
        disabled: `${classNameBase}-disabled`,
      }}
    >
      {children}
    </Accordion>
  );
}
